
import { Platform, StyleSheet } from "react-native";
import { genericStyles } from './styles.generic';
// const {debug} = useContext(DebugContext)


export default genericStyles;